//#region Libraries
import { useEffect, useState } from "react";
import { requestGetOrganizers } from "services/events/relatedToEvents";
//#endregion
//#region Utils
import { INIT_FILTER_FIELDS } from "../constants";
//#endregion

const useFilters = () => {
	//#region States
	const [filters, setFilters] = useState({ ...INIT_FILTER_FIELDS });
	const [organizerList, setOrganizerList] = useState([]);
	//#endregion
	//#region Effects
	useEffect(() => {
		fillData();
	}, []);
	//#endregion
	//#region Functions
	const changeField = (field, value) => {
		setFilters(prev => ({
			...prev,
			[field]: typeof value === "function" ? value(prev[field]) : value,
		}));
	};
	const isClearedFilters = () => {
		const clearedFilterFields = Object.keys(filters).every(key => {
			return filters[key] === INIT_FILTER_FIELDS[key];
		});
		return clearedFilterFields;
	};
	const clearFields = () => {
		setFilters({ ...INIT_FILTER_FIELDS });
	};
	const fillData = async () => {
		fillOrganizerList();
	};
	const fillOrganizerList = async () => {
		const data = await requestGetOrganizers();
		setOrganizerList(data);
	};
	//#endregion
	return {
		value: filters,
		change: changeField,
		clear: clearFields,
		isCleared: isClearedFilters,
		data: {
			organizerList,
		},
	};
};

export default useFilters;
